const freeze = Object.freeze

/** Action log firebase */
const ActionTypeFireBase = freeze({
    View: 'View',
    Print: 'Print',
    Update: 'Update'
  })

const AppNameFireBase = freeze({
    Process: 'Process'
  })

const SocketEvent = freeze({
  Connection: 'connection',
  SendNotify: 'SendNotify',
  NewNotify: 'NewNotify',
  JoinRoomSelf: 'JoinRoomSelf',
  OnJoinRoomSuccess: 'OnJoinRoomSuccess',
  LeaveRoom: 'leave_room'
})


export { ActionTypeFireBase }
export { AppNameFireBase }
export { SocketEvent }